import { render, staticRenderFns } from "./formRenderHeader.vue?vue&type=template&id=6646fccb&"
import script from "./formRenderHeader.vue?vue&type=script&lang=js&"
export * from "./formRenderHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports